import { useState, useEffect } from "react";
import { Modal, Table, Button, Spin, message, Empty, Avatar, Tag } from "antd";
import PropTypes from "prop-types";
import moment from "moment";
import _get from "lodash/get";
import request from "utils/api";
import "./styles.less";

const VoteHistoryModal = ({ candidateId, candidateName, visible, onClose }) => {
  const [loading, setLoading] = useState(false);
  const [votes, setVotes] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const fetchVoteHistory = async (page = 1, pageSize = 10) => {
    if (!candidateId) return;

    setLoading(true);
    try {
      const response = await request(
        "/api/contest/admin/vote-history",
        {
          candidateId,
          page,
          limit: pageSize,
        },
        { method: "GET" }
      );

      const data = _get(response, "data", {});
      setVotes(_get(data, "docs", []));
      setPagination({
        current: page,
        pageSize: pageSize,
        total: _get(data, "totalDocs", 0),
      });
    } catch (error) {
      console.error("Error fetching vote history:", error);
      message.error("Không thể tải lịch sử bình chọn");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (visible && candidateId) {
      fetchVoteHistory(pagination.current, pagination.pageSize);
    }
  }, [visible, candidateId]);

  const handleTableChange = (paginationConfig) => {
    fetchVoteHistory(paginationConfig.current, paginationConfig.pageSize);
  };

  const columns = [
    {
      title: "STT",
      key: "index",
      width: 60,
      align: "center",
      render: (_, record, index) => {
        const currentPage = pagination.current || 1;
        const pageSize = pagination.pageSize || 10;
        return (currentPage - 1) * pageSize + index + 1;
      },
    },
    {
      title: "Người bình chọn",
      dataIndex: "user",
      key: "user",
      width: 200,
      render: (user) => {
        if (!user) return <span>Người dùng ẩn danh</span>;
        return (
          <div className="voter-info">
            <Avatar size={32} src={_get(user, "avatar")}>
              {_get(user, "name", "?").charAt(0).toUpperCase()}
            </Avatar>
            <div className="voter-details">
              <div className="voter-name">{_get(user, "name", "Không tên")}</div>
              <div className="voter-email">{_get(user, "email", "")}</div>
            </div>
          </div>
        );
      },
    },
    {
      title: "Điểm bình chọn",
      dataIndex: "voteValue",
      key: "voteValue",
      width: 120,
      align: "center",
      render: (value) => (
        <Tag color="blue" style={{ fontSize: "14px", fontWeight: "bold" }}>
          {value || 1} điểm
        </Tag>
      ),
    },
    {
      title: "Cuộc thi",
      dataIndex: "contest",
      key: "contest",
      width: 180,
      render: (contest) => _get(contest, "name", "N/A"),
    },
    {
      title: "Thời gian bình chọn",
      dataIndex: "createdAt",
      key: "createdAt",
      width: 150,
      render: (date) => (
        <div>
          <div>{moment(date).format("DD/MM/YYYY")}</div>
          <div style={{ fontSize: "12px", color: "#999" }}>
            {moment(date).format("HH:mm:ss")}
          </div>
        </div>
      ),
    },
  ];

  return (
    <Modal
      title={`Lịch sử bình chọn - ${candidateName || "Thí sinh"}`}
      visible={visible}
      onCancel={onClose}
      width={1200}
      footer={[
        <Button key="close" onClick={onClose}>
          Đóng
        </Button>,
      ]}
      className="vote-history-modal"
    >
      <div className="vote-summary">
        <Tag color="green" style={{ fontSize: "14px", padding: "4px 12px" }}>
          Tổng số phiếu bầu: {pagination.total}
        </Tag>
      </div>
      <Spin spinning={loading}>
        {votes.length === 0 && !loading ? (
          <Empty description="Chưa có lượt bình chọn nào" />
        ) : (
          <Table
            columns={columns}
            dataSource={votes}
            rowKey="_id"
            pagination={pagination}
            onChange={handleTableChange}
            scroll={{ x: 800 }}
            size="small"
          />
        )}
      </Spin>
    </Modal>
  );
};

VoteHistoryModal.propTypes = {
  candidateId: PropTypes.string,
  candidateName: PropTypes.string,
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default VoteHistoryModal;